import script from "./TopDomains.vue?vue&type=script&setup=true&lang=js"
export * from "./TopDomains.vue?vue&type=script&setup=true&lang=js"

import "./TopDomains.vue?vue&type=style&index=0&id=77d17d08&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77d17d08"]])

export default __exports__